"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherOnSaleType = exports.UserType = exports.UserLoggedInAs = exports.UserGender = exports.SubscriptionType = exports.SubscriptionState = exports.SubscriptionChannel = exports.RequestType = exports.RecommendationDevice = exports.RecommendationContext = exports.ReclamationType = exports.ReclamationAccessPolicy = exports.ProductListNavigation = exports.ProductListImageFormat = exports.ProductListFilterOptionsSorting = exports.ProductListDevice = exports.ProductListArticlesSortOption = exports.PaybackApprovalStatus = exports.OrderType = exports.OrderItemStatus_V2 = exports.OrderItemProcess = exports.OrderDocumentType = exports.LoginFlow = exports.Locale = exports.EmailValidationDetailsResult = exports.EmailValidationDetailsReason = exports.DynamicYieldPageContexType = exports.DeviceType = exports.ContentCtaButtonType = exports.CheckoutPaymentMethodType = exports.CategoryListCategoryIn = exports.CategoryImageFormat = exports.CategoryFilterOptionsSorting = exports.CategoryDevice = exports.CategoryArticlesSortOption = exports.ArticlesSortingScore = exports.ArticleShowroomImageSize = exports.ArticleResourceType = exports.ArticleImageType = exports.ArticleImageFormat = exports.ArticleDeliveryType = void 0;
var ArticleDeliveryType;
(function (ArticleDeliveryType) {
    ArticleDeliveryType["FurnitureShipping"] = "FURNITURE_SHIPPING";
    ArticleDeliveryType["ParcelService"] = "PARCEL_SERVICE";
    ArticleDeliveryType["ShippingCompany"] = "SHIPPING_COMPANY";
    ArticleDeliveryType["Unknown"] = "UNKNOWN";
})(ArticleDeliveryType = exports.ArticleDeliveryType || (exports.ArticleDeliveryType = {}));
var ArticleImageFormat;
(function (ArticleImageFormat) {
    ArticleImageFormat["Jpg"] = "JPG";
    ArticleImageFormat["Png"] = "PNG";
    ArticleImageFormat["Gif"] = "GIF";
    ArticleImageFormat["Webp"] = "WEBP";
})(ArticleImageFormat = exports.ArticleImageFormat || (exports.ArticleImageFormat = {}));
var ArticleImageType;
(function (ArticleImageType) {
    ArticleImageType["AssemblyInstruction"] = "ASSEMBLY_INSTRUCTION";
    ArticleImageType["Fabric"] = "FABRIC";
    ArticleImageType["Mood"] = "MOOD";
    ArticleImageType["Sketch"] = "SKETCH";
    ArticleImageType["AngularPerspective"] = "ANGULAR_PERSPECTIVE";
    ArticleImageType["Front"] = "FRONT";
    ArticleImageType["Back"] = "BACK";
    ArticleImageType["SideLeft"] = "SIDE_LEFT";
    ArticleImageType["SideRight"] = "SIDE_RIGHT";
    ArticleImageType["Top"] = "TOP";
    ArticleImageType["Detail"] = "DETAIL";
    ArticleImageType["Function"] = "FUNCTION";
    ArticleImageType["FunctionActive"] = "FUNCTION_ACTIVE";
    ArticleImageType["IconSeal"] = "ICON_SEAL";
    ArticleImageType["Accessory"] = "ACCESSORY";
    ArticleImageType["WardrobeSize"] = "WARDROBE_SIZE";
    ArticleImageType["WardrobeDoors"] = "WARDROBE_DOORS";
    ArticleImageType["WardrobeDesign"] = "WARDROBE_DESIGN";
    ArticleImageType["WardrobeInterior"] = "WARDROBE_INTERIOR";
    ArticleImageType["Set"] = "SET";
    ArticleImageType["AngularLeft"] = "ANGULAR_LEFT";
    ArticleImageType["AngularRight"] = "ANGULAR_RIGHT";
    ArticleImageType["Packaging"] = "PACKAGING";
    ArticleImageType["InnerView"] = "INNER_VIEW";
})(ArticleImageType = exports.ArticleImageType || (exports.ArticleImageType = {}));
var ArticleResourceType;
(function (ArticleResourceType) {
    ArticleResourceType["Image"] = "IMAGE";
    ArticleResourceType["AssemblyInstruction"] = "ASSEMBLY_INSTRUCTION";
    ArticleResourceType["Model_3D"] = "MODEL_3D";
    ArticleResourceType["DataSheet"] = "DATA_SHEET";
    ArticleResourceType["ShareImage"] = "SHARE_IMAGE";
})(ArticleResourceType = exports.ArticleResourceType || (exports.ArticleResourceType = {}));
var ArticleShowroomImageSize;
(function (ArticleShowroomImageSize) {
    ArticleShowroomImageSize["DesktopX1"] = "DESKTOP_X1";
    ArticleShowroomImageSize["DesktopX2"] = "DESKTOP_X2";
    ArticleShowroomImageSize["DesktopX3"] = "DESKTOP_X3";
    ArticleShowroomImageSize["TabletX1"] = "TABLET_X1";
    ArticleShowroomImageSize["TabletX2"] = "TABLET_X2";
    ArticleShowroomImageSize["TabletX3"] = "TABLET_X3";
    ArticleShowroomImageSize["MobileX1"] = "MOBILE_X1";
    ArticleShowroomImageSize["MobileX2"] = "MOBILE_X2";
    ArticleShowroomImageSize["MobileX3"] = "MOBILE_X3";
})(ArticleShowroomImageSize = exports.ArticleShowroomImageSize || (exports.ArticleShowroomImageSize = {}));
var ArticlesSortingScore;
(function (ArticlesSortingScore) {
    ArticlesSortingScore["A"] = "A";
    ArticlesSortingScore["B"] = "B";
    ArticlesSortingScore["B1"] = "B1";
    ArticlesSortingScore["B2"] = "B2";
    ArticlesSortingScore["B3"] = "B3";
    ArticlesSortingScore["B4"] = "B4";
})(ArticlesSortingScore = exports.ArticlesSortingScore || (exports.ArticlesSortingScore = {}));
var CategoryArticlesSortOption;
(function (CategoryArticlesSortOption) {
    CategoryArticlesSortOption["PriceAsc"] = "PRICE_ASC";
    CategoryArticlesSortOption["PriceDesc"] = "PRICE_DESC";
    CategoryArticlesSortOption["DiscountDesc"] = "DISCOUNT_DESC";
    CategoryArticlesSortOption["FirstSellableAtDesc"] = "FIRST_SELLABLE_AT_DESC";
    CategoryArticlesSortOption["Popularity"] = "POPULARITY";
    CategoryArticlesSortOption["AverageRating"] = "AVERAGE_RATING";
})(CategoryArticlesSortOption = exports.CategoryArticlesSortOption || (exports.CategoryArticlesSortOption = {}));
var CategoryDevice;
(function (CategoryDevice) {
    CategoryDevice["Desktop"] = "DESKTOP";
    CategoryDevice["Mobile"] = "MOBILE";
    CategoryDevice["MobileApp"] = "MOBILE_APP";
})(CategoryDevice = exports.CategoryDevice || (exports.CategoryDevice = {}));
var CategoryFilterOptionsSorting;
(function (CategoryFilterOptionsSorting) {
    CategoryFilterOptionsSorting["Alphabetical"] = "ALPHABETICAL";
    CategoryFilterOptionsSorting["ByArticleCountDesc"] = "BY_ARTICLE_COUNT_DESC";
})(CategoryFilterOptionsSorting = exports.CategoryFilterOptionsSorting || (exports.CategoryFilterOptionsSorting = {}));
var CategoryImageFormat;
(function (CategoryImageFormat) {
    CategoryImageFormat["Jpg"] = "JPG";
    CategoryImageFormat["Png"] = "PNG";
    CategoryImageFormat["Gif"] = "GIF";
    CategoryImageFormat["Webp"] = "WEBP";
})(CategoryImageFormat = exports.CategoryImageFormat || (exports.CategoryImageFormat = {}));
var CategoryListCategoryIn;
(function (CategoryListCategoryIn) {
    CategoryListCategoryIn["MainNavigation"] = "MAIN_NAVIGATION";
    CategoryListCategoryIn["SideNavigation"] = "SIDE_NAVIGATION";
    CategoryListCategoryIn["VisualNavigation"] = "VISUAL_NAVIGATION";
    CategoryListCategoryIn["MobileLegacyNavigation"] = "MOBILE_LEGACY_NAVIGATION";
})(CategoryListCategoryIn = exports.CategoryListCategoryIn || (exports.CategoryListCategoryIn = {}));
var CheckoutPaymentMethodType;
(function (CheckoutPaymentMethodType) {
    CheckoutPaymentMethodType["CreditcardPayone"] = "CREDITCARD_PAYONE";
    CheckoutPaymentMethodType["MaestroPayone"] = "MAESTRO_PAYONE";
    CheckoutPaymentMethodType["InstallmentAfterpay"] = "INSTALLMENT_AFTERPAY";
    CheckoutPaymentMethodType["IdealPayone"] = "IDEAL_PAYONE";
    CheckoutPaymentMethodType["PrepaymentH24"] = "PREPAYMENT_H24";
    CheckoutPaymentMethodType["InvoiceH24"] = "INVOICE_H24";
    CheckoutPaymentMethodType["Free"] = "FREE";
    CheckoutPaymentMethodType["Paypal"] = "PAYPAL";
})(CheckoutPaymentMethodType = exports.CheckoutPaymentMethodType || (exports.CheckoutPaymentMethodType = {}));
var ContentCtaButtonType;
(function (ContentCtaButtonType) {
    ContentCtaButtonType["Primary"] = "PRIMARY";
    ContentCtaButtonType["Secondary"] = "SECONDARY";
})(ContentCtaButtonType = exports.ContentCtaButtonType || (exports.ContentCtaButtonType = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["TabletNativeIos"] = "TABLET_NATIVE_IOS";
    DeviceType["MobileNativeIos"] = "MOBILE_NATIVE_IOS";
    DeviceType["TabletNativeAndroid"] = "TABLET_NATIVE_ANDROID";
    DeviceType["MobileNativeAndroid"] = "MOBILE_NATIVE_ANDROID";
    DeviceType["TabletAndroid"] = "TABLET_ANDROID";
    DeviceType["TabletIos"] = "TABLET_IOS";
    DeviceType["MobileIos"] = "MOBILE_IOS";
    DeviceType["MobileAndroid"] = "MOBILE_ANDROID";
    DeviceType["MobileNative"] = "MOBILE_NATIVE";
    DeviceType["Tablet"] = "TABLET";
    DeviceType["MobilePhone"] = "MOBILE_PHONE";
    DeviceType["Desktop"] = "DESKTOP";
    DeviceType["Mobile"] = "MOBILE";
    DeviceType["Unknown"] = "UNKNOWN";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var DynamicYieldPageContexType;
(function (DynamicYieldPageContexType) {
    DynamicYieldPageContexType["Homepage"] = "HOMEPAGE";
    DynamicYieldPageContexType["Category"] = "CATEGORY";
    DynamicYieldPageContexType["Product"] = "PRODUCT";
    DynamicYieldPageContexType["Post"] = "POST";
    DynamicYieldPageContexType["Cart"] = "CART";
    DynamicYieldPageContexType["Other"] = "OTHER";
})(DynamicYieldPageContexType = exports.DynamicYieldPageContexType || (exports.DynamicYieldPageContexType = {}));
var EmailValidationDetailsReason;
(function (EmailValidationDetailsReason) {
    EmailValidationDetailsReason["InvalidEmail"] = "invalid_email";
    EmailValidationDetailsReason["InvalidDomain"] = "invalid_domain";
    EmailValidationDetailsReason["RejectedEmail"] = "rejected_email";
    EmailValidationDetailsReason["AcceptedEmail"] = "accepted_email";
    EmailValidationDetailsReason["LowQuality"] = "low_quality";
    EmailValidationDetailsReason["LowDeliverability"] = "low_deliverability";
    EmailValidationDetailsReason["NoConnect"] = "no_connect";
    EmailValidationDetailsReason["Timeout"] = "timeout";
    EmailValidationDetailsReason["InvalidSmtp"] = "invalid_smtp";
    EmailValidationDetailsReason["UnavailableSmtp"] = "unavailable_smtp";
    EmailValidationDetailsReason["UnexpectedError"] = "unexpected_error";
})(EmailValidationDetailsReason = exports.EmailValidationDetailsReason || (exports.EmailValidationDetailsReason = {}));
var EmailValidationDetailsResult;
(function (EmailValidationDetailsResult) {
    EmailValidationDetailsResult["Deliverable"] = "deliverable";
    EmailValidationDetailsResult["Undeliverable"] = "undeliverable";
    EmailValidationDetailsResult["Risky"] = "risky";
    EmailValidationDetailsResult["Unknown"] = "unknown";
})(EmailValidationDetailsResult = exports.EmailValidationDetailsResult || (exports.EmailValidationDetailsResult = {}));
var Locale;
(function (Locale) {
    Locale["DeAt"] = "de_AT";
    Locale["DeCh"] = "de_CH";
    Locale["DeDe"] = "de_DE";
    Locale["DeFfh"] = "de_FFH";
    Locale["FrBe"] = "fr_BE";
    Locale["FrCh"] = "fr_CH";
    Locale["FrFr"] = "fr_FR";
    Locale["ItIt"] = "it_IT";
    Locale["NlBe"] = "nl_BE";
    Locale["NlNl"] = "nl_NL";
})(Locale = exports.Locale || (exports.Locale = {}));
var LoginFlow;
(function (LoginFlow) {
    LoginFlow["WebsiteSession"] = "websiteSession";
    LoginFlow["RememberMe"] = "rememberMe";
    LoginFlow["Mobile"] = "mobile";
})(LoginFlow = exports.LoginFlow || (exports.LoginFlow = {}));
var OrderDocumentType;
(function (OrderDocumentType) {
    OrderDocumentType["Unknown"] = "UNKNOWN";
    OrderDocumentType["Invoice"] = "INVOICE";
    OrderDocumentType["CreditMemo"] = "CREDIT_MEMO";
    OrderDocumentType["DebitMemo"] = "DEBIT_MEMO";
    OrderDocumentType["DunningFirst"] = "DUNNING_FIRST";
    OrderDocumentType["DunningSecond"] = "DUNNING_SECOND";
    OrderDocumentType["DunningThird"] = "DUNNING_THIRD";
    OrderDocumentType["ReturnLabel"] = "RETURN_LABEL";
    OrderDocumentType["ReturnNote"] = "RETURN_NOTE";
    OrderDocumentType["ExchangeLabel"] = "EXCHANGE_LABEL";
    OrderDocumentType["ExchangeNote"] = "EXCHANGE_NOTE";
})(OrderDocumentType = exports.OrderDocumentType || (exports.OrderDocumentType = {}));
var OrderItemProcess;
(function (OrderItemProcess) {
    OrderItemProcess["Rejected"] = "REJECTED";
    OrderItemProcess["Remain"] = "REMAIN";
    OrderItemProcess["Lost"] = "LOST";
    OrderItemProcess["NormalReplaced"] = "NORMAL_REPLACED";
    OrderItemProcess["RemainReplaced"] = "REMAIN_REPLACED";
    OrderItemProcess["LostReplaced"] = "LOST_REPLACED";
})(OrderItemProcess = exports.OrderItemProcess || (exports.OrderItemProcess = {}));
var OrderItemStatus_V2;
(function (OrderItemStatus_V2) {
    OrderItemStatus_V2["Rejected"] = "REJECTED";
    OrderItemStatus_V2["Ordered"] = "ORDERED";
    OrderItemStatus_V2["Processing"] = "PROCESSING";
    OrderItemStatus_V2["Picked"] = "PICKED";
    OrderItemStatus_V2["Shipped"] = "SHIPPED";
    OrderItemStatus_V2["Delivered"] = "DELIVERED";
    OrderItemStatus_V2["ReturnRequested"] = "RETURN_REQUESTED";
    OrderItemStatus_V2["CorrectionRequested"] = "CORRECTION_REQUESTED";
    OrderItemStatus_V2["CancellationRequested"] = "CANCELLATION_REQUESTED";
    OrderItemStatus_V2["CancellationProcessing"] = "CANCELLATION_PROCESSING";
    OrderItemStatus_V2["Canceled"] = "CANCELED";
    OrderItemStatus_V2["CancellationRejected"] = "CANCELLATION_REJECTED";
})(OrderItemStatus_V2 = exports.OrderItemStatus_V2 || (exports.OrderItemStatus_V2 = {}));
var OrderType;
(function (OrderType) {
    OrderType["Undefined"] = "UNDEFINED";
    OrderType["Spareparts"] = "SPAREPARTS";
    OrderType["Sparepart"] = "SPAREPART";
    OrderType["Return"] = "RETURN";
    OrderType["Exchange"] = "EXCHANGE";
    OrderType["Temporary"] = "TEMPORARY";
    OrderType["Order"] = "ORDER";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var PaybackApprovalStatus;
(function (PaybackApprovalStatus) {
    PaybackApprovalStatus["Pending"] = "PENDING";
    PaybackApprovalStatus["Approved"] = "APPROVED";
    PaybackApprovalStatus["Failed"] = "FAILED";
})(PaybackApprovalStatus = exports.PaybackApprovalStatus || (exports.PaybackApprovalStatus = {}));
var ProductListArticlesSortOption;
(function (ProductListArticlesSortOption) {
    ProductListArticlesSortOption["PriceAsc"] = "PRICE_ASC";
    ProductListArticlesSortOption["PriceDesc"] = "PRICE_DESC";
    ProductListArticlesSortOption["DiscountDesc"] = "DISCOUNT_DESC";
    ProductListArticlesSortOption["FirstSellableAtDesc"] = "FIRST_SELLABLE_AT_DESC";
    ProductListArticlesSortOption["Popularity"] = "POPULARITY";
    ProductListArticlesSortOption["AverageRating"] = "AVERAGE_RATING";
})(ProductListArticlesSortOption = exports.ProductListArticlesSortOption || (exports.ProductListArticlesSortOption = {}));
var ProductListDevice;
(function (ProductListDevice) {
    ProductListDevice["Desktop"] = "DESKTOP";
    ProductListDevice["Mobile"] = "MOBILE";
    ProductListDevice["MobileApp"] = "MOBILE_APP";
})(ProductListDevice = exports.ProductListDevice || (exports.ProductListDevice = {}));
var ProductListFilterOptionsSorting;
(function (ProductListFilterOptionsSorting) {
    ProductListFilterOptionsSorting["Alphabetical"] = "ALPHABETICAL";
    ProductListFilterOptionsSorting["ByArticleCountDesc"] = "BY_ARTICLE_COUNT_DESC";
})(ProductListFilterOptionsSorting = exports.ProductListFilterOptionsSorting || (exports.ProductListFilterOptionsSorting = {}));
var ProductListImageFormat;
(function (ProductListImageFormat) {
    ProductListImageFormat["Jpg"] = "JPG";
    ProductListImageFormat["Png"] = "PNG";
    ProductListImageFormat["Gif"] = "GIF";
    ProductListImageFormat["Webp"] = "WEBP";
})(ProductListImageFormat = exports.ProductListImageFormat || (exports.ProductListImageFormat = {}));
var ProductListNavigation;
(function (ProductListNavigation) {
    ProductListNavigation["MainNavigation"] = "MAIN_NAVIGATION";
    ProductListNavigation["SideNavigation"] = "SIDE_NAVIGATION";
    ProductListNavigation["VisualNavigation"] = "VISUAL_NAVIGATION";
    ProductListNavigation["AliasNavigation"] = "ALIAS_NAVIGATION";
    ProductListNavigation["MobileAppNavigation"] = "MOBILE_APP_NAVIGATION";
})(ProductListNavigation = exports.ProductListNavigation || (exports.ProductListNavigation = {}));
var ReclamationAccessPolicy;
(function (ReclamationAccessPolicy) {
    ReclamationAccessPolicy["Disallowed"] = "DISALLOWED";
    ReclamationAccessPolicy["Optional"] = "OPTIONAL";
    ReclamationAccessPolicy["Required"] = "REQUIRED";
})(ReclamationAccessPolicy = exports.ReclamationAccessPolicy || (exports.ReclamationAccessPolicy = {}));
var ReclamationType;
(function (ReclamationType) {
    ReclamationType["Cancellations"] = "CANCELLATIONS";
    ReclamationType["ReturnsAndComplaints"] = "RETURNS_AND_COMPLAINTS";
})(ReclamationType = exports.ReclamationType || (exports.ReclamationType = {}));
var RecommendationContext;
(function (RecommendationContext) {
    RecommendationContext["Homepage"] = "homepage";
    RecommendationContext["HealthCheck"] = "healthCheck";
})(RecommendationContext = exports.RecommendationContext || (exports.RecommendationContext = {}));
var RecommendationDevice;
(function (RecommendationDevice) {
    RecommendationDevice["MobileSite"] = "MOBILE_SITE";
    RecommendationDevice["NativeApp"] = "NATIVE_APP";
    RecommendationDevice["Desktop"] = "DESKTOP";
})(RecommendationDevice = exports.RecommendationDevice || (exports.RecommendationDevice = {}));
var RequestType;
(function (RequestType) {
    RequestType["Cancellations"] = "CANCELLATIONS";
    RequestType["ReturnsAndComplaints"] = "RETURNS_AND_COMPLAINTS";
    RequestType["Help"] = "HELP";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
var SubscriptionChannel;
(function (SubscriptionChannel) {
    SubscriptionChannel["Email"] = "email";
})(SubscriptionChannel = exports.SubscriptionChannel || (exports.SubscriptionChannel = {}));
var SubscriptionState;
(function (SubscriptionState) {
    SubscriptionState["Subscribed"] = "subscribed";
    SubscriptionState["Unsubscribed"] = "unsubscribed";
    SubscriptionState["Confirmed"] = "confirmed";
    SubscriptionState["Pending"] = "pending";
})(SubscriptionState = exports.SubscriptionState || (exports.SubscriptionState = {}));
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Newsletter"] = "newsletter";
    SubscriptionType["WishlistReminder"] = "wishlistReminder";
    SubscriptionType["CartReminder"] = "cartReminder";
    SubscriptionType["ProductRecommendation"] = "productRecommendation";
    SubscriptionType["DirectMail"] = "directMail";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var UserGender;
(function (UserGender) {
    UserGender["Male"] = "MALE";
    UserGender["Female"] = "FEMALE";
})(UserGender = exports.UserGender || (exports.UserGender = {}));
var UserLoggedInAs;
(function (UserLoggedInAs) {
    UserLoggedInAs["Anonymous"] = "ANONYMOUS";
    UserLoggedInAs["Partial"] = "PARTIAL";
    UserLoggedInAs["Guest"] = "GUEST";
    UserLoggedInAs["User"] = "USER";
})(UserLoggedInAs = exports.UserLoggedInAs || (exports.UserLoggedInAs = {}));
var UserType;
(function (UserType) {
    UserType["Private"] = "private";
    UserType["Business"] = "business";
})(UserType = exports.UserType || (exports.UserType = {}));
var VoucherOnSaleType;
(function (VoucherOnSaleType) {
    VoucherOnSaleType["NotOnSale"] = "NOT_ON_SALE";
    VoucherOnSaleType["AllItems"] = "All_ITEMS";
    VoucherOnSaleType["OnlyOnSale"] = "ONLY_ON_SALE";
})(VoucherOnSaleType = exports.VoucherOnSaleType || (exports.VoucherOnSaleType = {}));
